import moment from "moment";

export const LAST_TRIPS_PANEL_WIDTH = 380;

export const getLastTripsSearchParams = () => {
  const startDate = moment().subtract(3, "months").startOf("day");
  const endDate = moment().endOf("day");

  return {
    page: 1,
    itemsPerPage: 10,
    includeRidesWithoutDriver: true,
    startedWithoutIgnition: true,
    orderBy: [{ field: "startDate", ascending: false }],
    startDate: `${startDate.format("YYYY-MM-DD")}T00:00:00${startDate.format("Z")}`,
    endDate: `${endDate.format("YYYY-MM-DD")}T23:59:59${endDate.format("Z")}`
  };
};
